import {
	cancelElectronicReceipts,
	confirmActivationMissingOrders,
	confirmActivationMissingStatus,
	confirmActivationMissingStatusClear,
	getActivationMissingOrders
} from 'actions'
import AutoGenerateProgressBar from 'components/AutoGenerate/AutoGenerateProgressBar'
import NotificationError from 'components/common/notificationsErrors'
import { Formik, FormikProps } from 'formik'
import { getInitValues, getValidationSchema } from 'lib/FieldValidations'
import { IActivationMissingOrdersFormValues } from 'models/ActivationMissingOrders'
import React, { Component, Fragment } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import { LANDING } from 'utils/RoutePath'
import ActivationMissingInputs from '../ActivationMissingInputs'
import {
	IActivationMissingFiltersProps,
	IActivationMissingFiltersState
} from './ActivationMissingFiltersType'

class ActivationMissingFilters extends Component<
	IActivationMissingFiltersProps,
	IActivationMissingFiltersState
> {
	timer: any = null
	excludeFields: Array<string> = ['enviar', 'salir', 'mensaje']

	constructor(props: IActivationMissingFiltersProps) {
		super(props)
		this.state = {
			showBar: false
		}
	}

	componentDidUpdate(prevProps: IActivationMissingFiltersProps): void {
		const { confirmItems, statusConfirmItems } = this.props

		if (
			!_.isEqual(prevProps.statusConfirmItems, statusConfirmItems) &&
			!_.isEmpty(statusConfirmItems) &&
			statusConfirmItems?.proceso_finalizado === 1
		) {
			this.cleanIntervale()
			this.handleGetItems()
		}

		if (
			!_.isEqual(confirmItems, prevProps.confirmItems) &&
			!_.isEmpty(confirmItems)
		) {
			this.handlePollStatus()
		}
	}

	/**
	 * get all new items
	 */
	handleGetItems = () => {
		const { idOperacion } = this.props
		this.props.getActivationMissingOrders({
			idOperacion,
			page_number: 1,
			page_size: 10,
			fec_fin: '',
			fec_ini: '',
			Sucursal: ''
		})
	}

	handleValidateElectronicReceipt = () => {
		const { rowSelected, idOperacion } = this.props
		const lista = rowSelected.map((row) => ({ id: row }))
		this.props.confirmActivationMissingOrders({ lista, idOperacion })
		this.setState({ showBar: true })
	}

	handleCancelForm = () => {
		const { idOperacion } = this.props
		this.cleanIntervale()
		this.props.cancelElectronicReceipts({ idOperacion })
		this.setState({ showBar: false })
	}

	componentWillUnmount = () => {
		this.cleanIntervale()
	}

	/**
	 * to stop polling
	 */
	cleanIntervale = () => {
		clearInterval(this.timer)
		this.timer = null
		// this.setState({ showBar: false })
		// this.props.confirmActivationMissingStatusClear()
	}

	/**
	 * api is called after confirm
	 */
	handlePollStatus = () => {
		const time = process.env.REACT_APP_POLLING_TIME
			? parseInt(process.env.REACT_APP_POLLING_TIME)
			: 3000
		this.timer = setInterval(() => this.getStatus(), time)
	}

	/**
	 * to call api who get status
	 */
	getStatus = () => {
		const { idOperacion } = this.props
		this.props.confirmActivationMissingStatus({
			idOperacion
		})
	}

	render() {
		const {
			fields,
			t,
			idOperacion,
			initialState,
			rowSelected,
			statusConfirmItems,
			authUser
		} = this.props

		const { userCompany } = authUser
		const { showBar } = this.state

		const initialValues = fields.length
			? getInitValues(fields, initialState, this.excludeFields)
			: {}

		const validationSchema = getValidationSchema(
			fields,
			t,
			this.excludeFields,
			[]
		)

		return (
			<Formik
				initialValues={initialValues}
				onSubmit={(values: any) => {
					this.props.handleFilterSearch({ ...values })
				}}
				validationSchema={validationSchema}
				enableReinitialize={true}
				render={(
					props: FormikProps<Partial<IActivationMissingOrdersFormValues>>
				) => {
					const {
						values,
						handleChange,
						handleBlur,
						setFieldValue,
						setFieldTouched
					} = props

					return (
						<Fragment>
							<Col sm={12}>
								<NotificationError
									errors={props.errors}
									touched={props.touched}
								/>
							</Col>
							<Form
								onSubmit={(e) => props.handleSubmit(e as any)}
								className="voucher-info-form"
							>
								<Row className={'pb-2 pr-3'}>
									<ActivationMissingInputs
										{...{
											values,
											handleChange,
											handleBlur,
											setFieldValue,
											setFieldTouched,
											fields,
											idOperacion
										}}
									/>
								</Row>
								<Row className="justify-content-md-center">
									<Col sm={{ span: 'auto' }} className={'mt-2'}>
										<Button style={{ minWidth: '125px' }} type={'submit'}>
											{t('global.filter')}
										</Button>
									</Col>
									<Col sm={{ span: 'auto' }} className={'mt-2'}>
										<Button
											style={{ minWidth: '105px' }}
											type={'button'}
											onClick={() => {
												this.props.clearFilters()
												props.resetForm()
											}}
										>
											{t('global.clear')}
										</Button>
									</Col>
									<Col sm={{ span: 'auto' }} className={'mt-2'}>
										<Button
											style={{ minWidth: '105px' }}
											type={'button'}
											onClick={this.handleValidateElectronicReceipt}
											disabled={_.isEmpty(rowSelected)}
										>
											{t('form.button.submit')}
										</Button>
									</Col>
									<Col sm={{ span: 'auto' }} className={'mt-2'}>
										<Button
											style={{ minWidth: '105px' }}
											type={'button'}
											onClick={() => {
												this.props.history.push(`${LANDING}/${userCompany}`)
											}}
										>
											{t('form.button.exit')}
										</Button>
									</Col>
								</Row>
								<Row className="mb-3">
									{showBar && (
										<AutoGenerateProgressBar
											generatedStatus={statusConfirmItems}
											handleCancelProgress={this.handleCancelForm}
										/>
									)}
								</Row>
							</Form>
						</Fragment>
					)
				}}
			/>
		)
	}
}

const mapStateToProps = ({ auth, activationMissing }: any) => {
	const { confirmItems, statusConfirmItems } = activationMissing
	const { authUser } = auth
	return { authUser, confirmItems, statusConfirmItems }
}

const mapDispatchToProps = {
	confirmActivationMissingOrders,
	confirmActivationMissingStatus,
	cancelElectronicReceipts,
	getActivationMissingOrders,
	confirmActivationMissingStatusClear
}

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(withTranslation()(ActivationMissingFilters))
)
